<div class="header-main details-info" [ngClass]="{'with-overlay': modalView == MODAL_PENDING_CHANGES}">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == MODAL_PENDING_CHANGES"
        [type]="'warning'"
        [message]="'Editing tags'"
        [text]="'There are tag changes pending to save.<br/>If you continue, the changes made will be lost and not saved to the project.<br/>Do you wish to leave?'"
        [buttonText]="'OK'"
        (action)="onModalExitEdition()"
        [secondButtonText]="'Cancel'"
        (secondButtonAction)="onModalCancel()">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback"  *ngIf="modalView == MODAL_LABELS_UPDATE_ERROR" 
        [type]="'fail'"
        [message]="'Error'"
        [text]="'Something went wrong updating tags. Please try again. If the error persists, please reach out to our support team through the Help Me button.'"
        [buttonText]="'Retry'" (action)="onModalErrorDismiss()">
    </core-layout-modal-feedback>
    <core-title-section [title]="'Project <small>(#' + project.id+ ')</small>'"></core-title-section>
    <div [hidden]="edit" class="labels-edit-container"><core-labels-text [labels]="project.labels"></core-labels-text></div>
    <core-helpers-navigation-three-dots-menu [menu]="menu" (action)="onMenuSelect($event)"></core-helpers-navigation-three-dots-menu>
    <div *ngIf="edit" class="edit-tags-mod" [ngClass]="{'uploded-warning-displayed': uploaded }">
        <app-helpers-labels-edit-diff-box
            [labels]="editorLabels"
            [allowClose]="true"
            [minLabels]="1"
            (labelsChange)="setLabels($event)"
            (close)="toggleEdit()"
        ></app-helpers-labels-edit-diff-box>
        <div class="box_fieldset">
            <core-helpers-forms-button-white 
                [disabled]="!pendingChanges || freezed"
                [text]="'Save tags'" 
                (click)="onTagsConfirm()"
            ></core-helpers-forms-button-white>
        </div>
        <core-helpers-box-alert-message-icon
            [hidden]="!uploaded || freezed"
            [text]="'The tags of all uploaded Artworks will be modified.'"
            [icon]="'alert_notice'"
        ></core-helpers-box-alert-message-icon>
        <core-helpers-box-alert-message-icon 
          [hidden]="!freezed" 
          [text]="'The tags are being updated. <br> Please wait...'"
          [icon]="'alert_notice'"></core-helpers-box-alert-message-icon>
    </div>
  </div>
